import styled from 'styled-components'

import { BluredBlock } from 'components/Layout'

export const DetailsBlockContainer = styled(BluredBlock)`
  margin-top: 24px;
`
